import axios from 'axios'

const util = require('../../util.js')

const default_filter = {
  userId: null,
  organizationNumber: null,
  orderId: null,
  sourceOrderLineId: null,
  usageRights: null,
  status: null,
  isValid: Boolean(true),
  licenseModel: [],
  includeBundledProducts: Boolean(false),
  product: null,
  departments: null,
}

const default_paging = {
  currentPage: 1,
  perPage: 25,
  perPageAlternatives: [25, 50, 100],
  sortBy: 'productName',
  sortDesc: false,
  totalRows: 0
}

const default_create_state = {
  licenseModel: 'SCHOOL',
  channel: null,
  ownership: 'ORGANIZATION',
  licenseType: 'USAGE_RIGHTS_UNLIMITED',
  usageRights: -1,
  ownerOrganizationNumber: null,
  ean: null,
  ownerUserId: null,
  ownerUserName: null,
  licenseId: null,
  description: null,
  loading: false
}
const default_bulk_state = {
  organizationNumbers: null,
  eans: null,
  description: null,
  validFrom: null,
  validTo: null,
  usageRights: null
}

const state = {
  licenses: [],
  filter: { ...default_filter },
  paging: { ...default_paging },
  license: {},
  create: { ...default_create_state },
  loading: false,
  createLoading: false,
  bulkParameters: { ...default_bulk_state },
}

const mutations = {
  UPDATE_LICENSES (state, payload) {
    state.licenses = payload.response
    state.paging.totalRows = payload.resultCount
  },
  UPDATE_FILTER (state, payload) {
    state.filter = payload
  },
  UPDATE_PAGING (state, payload) {
    state.paging = payload
  },
  GET_LICENSES_BY_CUSTOMER_ORG_NUMBER_OR_USER_ID (state, payload) {
    state.filter.organizationNumber = payload.customerOrganizationNumber
    state.filter.userId = payload.customerUserId
    state.filter.ean = payload.ean
  },
  UPDATE_LICENSE (state, payload) {
    state.license = payload
  },
  UPDATE_CREATE_LICENSE (state, payload) {
    state.create = payload
  },
  RESET_CREATE_STATE (state, payload) {
    state.create = payload
  },
  UPDATE_USER (state, payload) {
    state.create.ownerUserId = payload.userId
    state.create.ownerUserName = payload.fullName
  },
  UPDATE_EAN (state, payload) {
    state.create.ean = payload
  },
  UPDATE_FORM_DISABLE_INDICATOR (state, payload) {
    state.loading = payload
  },
  UPDATE_CREATE_FORM_DISABLE_INDICATOR (state, payload) {
    state.createLoading = payload
  },
  RESET_BULK_PARAMETERS (state, payload) {
    state.bulkParameters = payload
  },
  UPDATE_ORGANIZATION_NUMBER (state, payload) {
    console.log(payload)
    state.filter.organizationNumber = payload
    state.create.ownerOrganizationNumber = payload
  },
  UPDATE_USER_ID (state, payload) {
    state.filter.userId = payload
    state.create.ownerUserId = payload
  },
  RESET_USER_ID (state) {
    state.filter.userId = null
  },
  UPDATE_LICENSE_MODEL (state, payload) {
    state.create.licenseModel = payload
  },
  UPDATE_CHANNEL (state, payload) {
    state.create.channel = payload
  },
  GET_LICENSE_BY_ORDER_DETAILS (state, payload) {
    state.filter.orderId = payload.orderId
    state.filter.sourceOrderLineId = payload.sourceOrderLineId
  },
  RESET_SOURCE_ORDER_LINE_ID (state){
    state.filter.sourceOrderLineId = null
  },
  UPDATE_DEPARTMENT(state, payload) {
    state.filter.departments = payload
  },
}

const actions = {
  async getLicenses ({ commit, dispatch }, save = true) {
    commit('UPDATE_FORM_DISABLE_INDICATOR', true)
    let licenses;
    try {
      await dispatch('getSelectedActiveProfile')
       licenses = await axios.get(process.env.VUE_APP_INTERNAL_API_BASEURL + '/license/', {
        params: {
          userId: util.emptyToNull(state.filter.userId),
          organizationNumber: util.emptyToNull(state.filter.organizationNumber),
          ean: util.isEan(state.filter.product) === true ? state.filter.product : null,
          productName: util.isEan(state.filter.product) === false ? state.filter.product : null,
          status: util.emptyToNull(state.filter.status),
          licenseModel: util.addQueryParam(state.filter.licenseModel, 'licenseModel'),
          isValid: state.filter.isValid,
          includeBundledProducts: state.filter.includeBundledProducts ? 'true' : null,
          orderId: util.emptyToNull(state.filter.orderId),
          sourceOrderLineId: util.emptyToNull(state.filter.sourceOrderLineId),
          pageNumber: util.emptyToNull(state.paging.currentPage),
          pageSize: util.emptyToNull(state.paging.perPage),
          orderBy: state.paging.sortBy + ':' + (state.paging.sortDesc ? 'desc' : 'asc'),
          departments: util.emptyToNull(state.filter.departments),
        }
      })
      if (licenses.data.response.length > 0) {
        let organizationNumbers = new Set()
        let ownerUserIds = new Set()
        licenses.data.response.forEach(license => {
          if (license.ownership === 'ORGANIZATION') {
            organizationNumbers.add(license.ownerOrganizationNumber)
          }
          if (license.ownership === 'PRIVATE') {
            ownerUserIds.add(license.ownerUserId)
          }
        })

        const organizations = await dispatch('getOrganizations', organizationNumbers)
        let users;
        if (ownerUserIds.size > 0) {
          users = await dispatch('getUsers', ownerUserIds)
        }
        licenses.data.response.forEach(license => {
          if (license.ownership === 'ORGANIZATION') {
            organizations.response.forEach(organization => {
              if (license.ownerOrganizationNumber === organization.organizationNumber) {
                license.organizationName = organization.name
              }
            })
          }
          if (license.ownership === 'PRIVATE') {
            if (users.has(license.ownerUserId)) {
              license.organizationName = users.get(license.ownerUserId)
            } else {
              license.organizationName = null
            }
          }
          if (license.ownership === null || license.ownership === undefined) {
            license.organizationName = '-'
          }
        })
      }
      if (save) {
        commit('UPDATE_LICENSES', licenses.data)
      }
      return licenses.data
    }
    finally {
      commit('UPDATE_FORM_DISABLE_INDICATOR', false)
    }
  },
  resetFilter ({ commit }) {
    commit('UPDATE_PAGING', { ...default_paging })
    commit('UPDATE_FILTER', { ...default_filter })
    state.licenses = []
  },
  getLicensesByCustomerOrgNumberOrUserIdOrEan ({ commit }, payload) {
    commit('GET_LICENSES_BY_CUSTOMER_ORG_NUMBER_OR_USER_ID', payload)
  },
  clearLicense ({ commit }) {
    commit('UPDATE_LICENSE', {})
  },
  async getLicense ({ dispatch, commit }, id) {
    let license = await axios.get(process.env.VUE_APP_INTERNAL_API_BASEURL + '/license/' + id)

    if (license.data.ownership === 'ORGANIZATION') {
      const school = await dispatch('getOrganizations', [license.data.ownerOrganizationNumber])
      if (school && school.response.length > 0) {
        license.data.ownerOrganizationName = school.response[0].name
      }
    }
    if (license.data.ownership === 'PRIVATE') {
      let ownerUserIds = new Set()
      if (license.data.ownerUserId !== null && license.data.ownerUserId !== "") {
        ownerUserIds.add(license.data.ownerUserId)
        const user = await dispatch('getUsers', ownerUserIds)
        license.data.ownerFullName = user.get(license.data.ownerUserId)
      }
    }
    commit('UPDATE_LICENSE', license.data)
  },
  async create ({ commit }) {
    commit('UPDATE_CREATE_FORM_DISABLE_INDICATOR', true)
    await axios
      .post(process.env.VUE_APP_INTERNAL_API_BASEURL + '/license/', state.create)
      .then((response) => {
        commit('UPDATE_CREATE_LICENSE', response.data[0])
      }).finally(() => {
        commit('UPDATE_CREATE_FORM_DISABLE_INDICATOR', false)
      })
  },
  async updateLicense ({ commit }, id) {
    await axios
      .put(process.env.VUE_APP_INTERNAL_API_BASEURL + '/license/' + id, state.license)
      .then((response => {
        commit('UPDATE_LICENSE', response.data)
      }))
  },
  resetCreateLicense ({ commit }) {
    commit('RESET_CREATE_STATE', { ...default_create_state })
  },
  updateUser ({ commit }, owner) {
    commit('UPDATE_USER', owner)
  },
  updateEan ({ commit }, ean) {
    commit('UPDATE_EAN', ean)
  },
  resetBulkParameters ({ commit }) {
    commit('RESET_BULK_PARAMETERS', { ...default_bulk_state })
  },
  getOrganizations ({ dispatch }, organizationNumbers) {
    let organizations
    if (organizationNumbers.size > 0) {
      try {
        organizations = dispatch('organizations/getOrganizationByOrganizationNumbers', { organizationNumbers: organizationNumbers }, { root: true })
      } catch (error) {
        console.log('Error occurred :: ' + error.response.data.message)
      }
    }
    return organizations
  },
  getUsers ({ dispatch }, ownerUserIds) {
    return dispatch('users/getFullName', { userIds: ownerUserIds }, { root: true })
      .then(userResponse => userResponse)
  },
  getSelectedActiveProfile ({ commit, rootGetters }) {
    let isActiveProfileSelected = rootGetters['sessionStorage/isActiveProfileSet']
    if (isActiveProfileSelected) {
      let activeProfile = rootGetters['sessionStorage/activeProfile']
      if (activeProfile.activeProfileType === 'organization') {
        commit('UPDATE_ORGANIZATION_NUMBER', activeProfile.id)
      } else {
        commit('UPDATE_USER_ID', activeProfile.id)
      }
    }
  },
  resetOrganizationNumber ({ commit }) {
    commit('UPDATE_ORGANIZATION_NUMBER', null)
  },
  resetUserId ({ commit }) {
    commit('RESET_USER_ID')
  },
  updateLicenseModel ({ commit }, licenseModel) {
    commit('UPDATE_LICENSE_MODEL', licenseModel)
  },
  updateChannel ({ commit }, channel) {
    commit('UPDATE_CHANNEL', channel)
  },
  updatePaging ({ commit, dispatch }, paging) {
    paging.currentPage = state.paging.currentPage
    paging.perPage = state.paging.perPage
    paging.totalRows = state.paging.totalRows
    paging.perPageAlternatives = default_paging.perPageAlternatives
    commit('UPDATE_PAGING', paging)
    state.licenses = []
    dispatch('getLicenses')
  },
  getLicenseByOrderDetails ({ commit }, payload) {
    commit('GET_LICENSE_BY_ORDER_DETAILS', payload)
  },
  resetSourceOrderLineId ({ commit })  {
    commit('RESET_SOURCE_ORDER_LINE_ID')
  }
}

const getters = {
  filter: state => state.filter,
  licenses: state => state.licenses,
  paging: state => state.paging,
  license: state => state.license,
  create: state => state.create,
  loading: state => state.loading,
  createLoading: state => state.createLoading,
  bulkParameters: state => state.bulkParameters,
}

const licensesModule = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default licensesModule
